/** @graphql cc **/

import gql from 'graphql-tag';

export const SpaceOperationsQuery = gql`
	query SpaceOperationsQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			operations {
				operation
				targetType
			}
		}
	}
`;
